import { render, staticRenderFns } from "./AdminMoved.vue?vue&type=template&id=7af5425e"
import script from "./AdminMoved.vue?vue&type=script&lang=js"
export * from "./AdminMoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports